import { NgModule } from '@angular/core';
import { LibAffordabilityPassportIconComponent } from './lib-affordability-passport-icon.component';

@NgModule({
  declarations: [LibAffordabilityPassportIconComponent],
  imports: [],
  exports: [LibAffordabilityPassportIconComponent],
})
export class LibAffordabilityPassportIconModule {}
